import { StepStage } from '@philips-internal/oswald-ui-constants';
import { isFunction } from '@philips-internal/oswald-ui-utils';
var AdjacentStep;
(function (AdjacentStep) {
    AdjacentStep[AdjacentStep["NEXT"] = 1] = "NEXT";
    AdjacentStep[AdjacentStep["PREVIOUS"] = -1] = "PREVIOUS";
})(AdjacentStep || (AdjacentStep = {}));
function findAdjacentStepIdentifier(modifier, current, steps) {
    const identifiers = getIdentifiers(steps);
    const identifierIndex = identifiers.findIndex((key) => current === key);
    const adjacentStepIndex = identifierIndex + modifier;
    const adjacentStepIdentifier = identifiers[adjacentStepIndex];
    return adjacentStepIdentifier;
}
function createStep(step, options) {
    return {
        ...step,
        ...options,
    };
}
function getStepProperties(readOnly, mode, steps, step) {
    const stepReadOnly = readOnly ? readOnly : step.readOnly;
    const stepProperties = steps[step.identifier];
    return {
        ...step,
        ...stepProperties,
        mode,
        readOnly: stepReadOnly,
    };
}
function editStep(previousIdentifier, editIdentifier, currentSteps, resultCallback) {
    const steps = { ...currentSteps };
    const identifiers = getIdentifiers(currentSteps);
    const editIdentifierIndex = identifiers.findIndex((key) => editIdentifier === key);
    let currentIdentifierIndex = identifiers.findIndex((key) => previousIdentifier === key);
    while (currentIdentifierIndex > editIdentifierIndex) {
        const identifier = identifiers[currentIdentifierIndex];
        steps[identifier] = resetStep(steps[identifier]);
        currentIdentifierIndex--;
    }
    const step = steps[editIdentifier];
    steps[editIdentifier] = createStep(step, {
        collapsed: false,
        done: true,
        enabled: true,
        result: isFunction(resultCallback) ? resultCallback(editIdentifier) : null,
    });
    return { identifier: editIdentifier, steps };
}
function getIdentifiers(steps) {
    return Object.keys(steps);
}
function resetStep(step) {
    return createStep(step, {
        collapsed: true,
        done: false,
        enabled: false,
        result: null,
    });
}
function submitStep(identifier, currentSteps, resultCallback) {
    const steps = { ...currentSteps };
    const step = steps[identifier];
    steps[identifier] = createStep(step, {
        collapsed: true,
        done: true,
        enabled: true,
        result: isFunction(resultCallback) ? resultCallback(identifier) : null,
    });
    const identifiers = getIdentifiers(currentSteps);
    const identifierIndex = identifiers.findIndex((key) => identifier === key);
    const nextIdentifierIndex = identifierIndex + 1;
    const nextIdentifier = identifiers[nextIdentifierIndex];
    if (!nextIdentifier) {
        return { identifier, steps };
    }
    const nextStep = steps[nextIdentifier];
    steps[nextIdentifier] = createStep(nextStep, {
        collapsed: false,
        enabled: true,
    });
    return { identifier: nextIdentifier, steps };
}
function updateStages(identifier, steps) {
    const identifiers = getIdentifiers(steps);
    const index = identifiers.findIndex(id => id === identifier);
    const nextIndex = index >= identifiers.length - 1 ? -1 : index + 1;
    const previousIndex = index <= 0 ? -1 : index - 1;
    const stages = {
        [index]: StepStage.CURRENT,
        [nextIndex]: StepStage.NEXT,
        [previousIndex]: StepStage.PREV,
    };
    return identifiers.reduce((accumulator, identifier, index) => {
        const step = steps[identifier];
        const stage = stages[index] || StepStage.NONE;
        return {
            ...accumulator,
            [identifier]: { ...step, stage },
        };
    }, {});
}
export { AdjacentStep, createStep, editStep, findAdjacentStepIdentifier, getStepProperties, getIdentifiers, resetStep, submitStep, updateStages, };
//# sourceMappingURL=wizard-utils.js.map